import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {SafeHtmlPipeModule} from '../../pipes/safe-html/safe-html-pipe.module';
import {StripePaymentModule} from '../../components/stripe-payment/stripe-payment.module';
import {MaintenanceCalendarComponent} from './maintenance-calendar.component';
import {MaintenanceCalendarViewComponent} from './maintenance-calendar-view/maintenance-calendar-view.component';
import {MaintenanceCalendarModalComponent} from './maintenance-calendar-modal/maintenance-calendar-modal.component';
import {MaintenanceCalendarListComponent} from 'app/views/maintenance-calendar/maintenance-calendar-list/maintenance-calendar-list.component';
import {MaintenanceCalendarCalendarViewComponent} from './maintenance-calendar-calendar-view/maintenance-calendar-calendar-view.component';
import {MaintenanceCalendarService} from '../../services/maintenance-calendar.service';
import {MaintenanceCalendarFilterComponent} from '../../components/maintenance-calendar-filter/maintenance-calendar-filter.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        SafeHtmlPipeModule,
        StripePaymentModule,
        UtilsModule
    ],
    declarations: [
        MaintenanceCalendarComponent,
        MaintenanceCalendarViewComponent,
        MaintenanceCalendarModalComponent,
        MaintenanceCalendarListComponent,
        MaintenanceCalendarCalendarViewComponent,
        MaintenanceCalendarFilterComponent
    ],
    providers: [
        MaintenanceCalendarService
    ]
})
export class MaintenanceCalendarModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/maintenance-calendar/maintenance-calendar.module.ts